import type { FaireProductEntity } from "../../entity_types/product";

export const p_2ru57h5q8p: FaireProductEntity = {
  token: "p_2ru57h5q8p",
  type: "product",
  name: "Day 7 Gentle Clarifying Shampoo (Liter)",
  brandToken: "b_pav2jbzzry",
  brandName: "Hours Haircare",
  imageUrl:
    "https://cdn.faire.com/fastly/bae72aaa0a026bd50a436d15fba2ca49f07856123dfd36d3b03f3c5a50058d6d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff3703397308a00e3369f2ad337792038b6e74b4ffa9e3b335b5b49da98a246a.jpeg",
  ],
  priceDollars: 37.92,
  description:
    "Gently removes excess oil and product build up, for a clean styling canvas and a fresh feeling, without stripping hairs natural moisture. Perfect for a weekly reset.\n\nThis sulfate-free cleanser is a low-lather formula, working best as a first shampoo so your second, regular shampoo can perform better.\n\nSuitable for all hair types.\n\nBabassu oil soothes and moisturizes. Peppermint oil leaves the scalp feeling refreshed, while helping increase circulation, promoting healthy growth.\n\nColor and keratin safe, sulfate free, paraben free, mineral oil free, DEA free, phthalate free, gluten free, cruelty free & hypoallergenic\n\nGood Housekeeping’s Best Clarifying Shampoo for Curly Hair\n“It’s a great go-to for a reset. It even has peppermint oil for a fresh feeling clean that I really love.” \n\nMore than functional -- hOURS is founded by hairstylists and tested in salons on all hair types to deliver professional performance that works for the results you want, in the salon and at home.",
  tags: [],
  msrpDollars: 96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:37.987Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
